import { Grid } from "@mui/material";
import { dripOfferAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useAppDispatch, useImagePath } from "hooks";
import { DripOfferResponse } from "interfaces/drip-offer";
import { FeatureType } from "interfaces/feature-tracker";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { featureTrackerAPI } from "redux/apis";
import { onClosePopUp, onScrollToShopSection } from "redux/slices";
import {
	Body,
	Button,
	Container,
	Header,
	HeaderTitle,
	Text,
	Tiki,
	Title
} from "./styles";

interface DripOfferMissedEventProps {}

export const DripOfferMissedEvent: React.FC<DripOfferMissedEventProps> = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const { authToken } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const headImageUrl = getImage(dripOfferAssets.popupBackground);
	const tikiImageUrl = getImage(dripOfferAssets.tiki);
	const titleUrl = getImage(dripOfferAssets.title);
	const scale = useCalculateScale(378, 380);
	const { data }: { data?: DripOfferResponse } =
		featureTrackerAPI.endpoints.getFeatureTrackers.useQueryState({
			FeatureType: FeatureType.DRIP_OFFER,
			isAuthenticated: !!authToken?.value
		});

	const onClose = (goToShop?: boolean) => {
		const userHasRemainingActivity = data?.trackers?.some(
			(t) =>
				(t.offerPurchaseDate && t.nodes.some((n) => n.state === "available")) ||
				!t.offerPurchaseDate
		);
		if (goToShop && !userHasRemainingActivity) {
			navigate("/shop");
			dispatch(onScrollToShopSection("Featured Deals"));
		}
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		reportEvent("drip_offer", {
			source: "show_pop_up",
			pop_up_type: "event_finished"
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "drip_offer",
			event_type: "event_finished",
			action: "show_pop_up",
			source: "drip_offer",
			type: "drip_offer_missed_event"
		});
	}, []);

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={() => onClose(false)} />
			<Header data-image={headImageUrl}>
				<Tiki src={tikiImageUrl} alt="Tiki says Hi!" />
				<HeaderTitle src={titleUrl} />
			</Header>
			<Body>
				<Title>The event has ended</Title>
				<Text>Come back again next time!</Text>
				<Grid container /* spacing={{ xs: 1, sm: 2 }} */>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="endless_offer_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "100%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
					<Grid
						item
						xs={12}
						/* sm={isMobile ? 6 : 12} */
						display="flex"
						justifyContent="center"
					>
						<Button
							variant="contained"
							themeColor="secondary"
							sx={{ minWidth: { xs: "100%", sm: "100%" } }}
							onClick={() => onClose(true)}
						>
							Continue Shopping
						</Button>
					</Grid>
				</Grid>
			</Body>
		</Container>
	);
};
